import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {ErrorService} from '@app/services';
import {VideoSearchParams} from '../video-search-params';
import {VideoService} from '../video.service';
@Component({
  selector: 'hpf-video-count',
  templateUrl: './video-count.component.html'
})
export class VideoCountComponent implements OnInit {
  /** The filters */
  @Input() searchParams: VideoSearchParams = new VideoSearchParams();
  /** Count result */
  count: number;
  /** Load flag */
  loaded = false;
  /** Constructor */
  constructor(private videoService: VideoService,
              private errorService: ErrorService) {}
  /** Init */
  ngOnInit() {
    this.videoService.count(this.searchParams.toObject())
    .then((count) => {
      this.count = count;
      this.loaded = true;
    })
    .catch((error) => this.errorService.handle(error))
  }
}
